import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:4005"
    : "");

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Attach token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("akrithi_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 (expired token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("akrithi_token");
      localStorage.removeItem("akrithi_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// ---- Public endpoints ----

export const getDashboard = () => api.get("/api/dashboard");

export const refreshDashboard = () => api.post("/api/dashboard/refresh");

export const getSiteHistory = (siteId, hours = 24) =>
  api.get(`/api/dashboard/history/${siteId}?hours=${hours}`);

// ---- Auth endpoints ----

export const login = (username, password) =>
  api.post("/api/auth/login-json", { username, password });

export const getMe = () => api.get("/api/admin/me");

export const changePassword = (currentPassword, newPassword) =>
  api.post("/api/admin/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });

// ---- Admin endpoints ----

export const getHealthSummary = () => api.get("/api/admin/health-summary");

export const getSitesConfig = () => api.get("/api/admin/sites");

export default api;
